import React, { useEffect } from "react";

import { useUpdateFieldValue } from "../../../shared/hooks/mutations/useUpdateFieldValue";
import { useSaveIndicator } from "../../../hooks/useSaveIndicator";
import SaveIndicator from "../../SaveIndicator";
import FieldError from "../FieldError";
import { useEditorStore } from "../../../shared/stores/useEditorStore";

export default function BoolField({ name, field }) {
    // Gérer le cas où currentValue est undefined (nouveau model data)
    const safeCurrentValue = field.currentValue?.value ?? field.value?.value ?? false;

    const [fieldValue, setFieldValue] = React.useState(safeCurrentValue);
    const { status: saveStatus, trigger: triggerSave, resolve: resolveSave } = useSaveIndicator();
    const updateField = useUpdateFieldValue();
    const isReadOnly = !useEditorStore(s => s.userRights.right_to_write);
    const scenarioId = useEditorStore(s => s.scenarioId);

    useEffect(() => {
        const newValue = field.currentValue?.value ?? field.value?.value ?? false;
        setFieldValue(newValue);
    }, [field.currentValue?.value, field.value?.value])

    const onChange = (e) => {
        field.compute_error = null;
        const newValue = e.target.checked;

        if (field.currentValue) {
            field.currentValue.value = newValue;
        }

        triggerSave();
        updateField.mutate(
            { id: field.id, value: newValue, scenarioId: scenarioId ?? 0 },
            {
                onSuccess: () => {
                    resolveSave();
                },
            }
        );
        setFieldValue(newValue);
    }

    return (
        <div className="-mt-1 -ml-1">
            <div className="flex flex-row items-center">
                <input
                    type="checkbox"
                    checked={fieldValue}
                    onChange={onChange}
                    disabled={isReadOnly}
                    className="w-5 h-5 rounded border-slate-300 text-primary focus:ring-primary focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                />
                <SaveIndicator status={saveStatus} className="ml-2" />
            </div>
            <FieldError field={field} />
        </div>
    )
}
